import gql from 'graphql-tag';

export const getGame = gql`
	query getGame($id: ID!) {
		getGame(id: $id) {
			id
			merlinId
			title
			league {
				id
				name
				sport
				stack
			}
			startTime
			status
			sport
			offsets {
				items {
					segment
					offset
				}
			}
			teams {
				items {
					id
					merlinId
					name
					abbreviation
					logoUrl
				}
			}
			highlights(sortDirection: DESC, limit: 100) {
				items {
					id
					available
					availableTime
					type
					periods {
						items {
							title
						}
					}
					publishTime
				}
			}
			editorialHighlight {
				id
				periods {
					items {
						playId
						startPosition
						endPosition
						startGameTime {
							segmentId
							segment
							position
						}
						gameEndTime {
							segmentId
							position
						}
						source {
							type
							startTime
							endTime
							channelId
						}
						endScore
						title
						shortText
						description
						type
						team {
							id
						}
					}
				}
			}
		}
	}
`;

export const getGameHighlights = gql`
	query getGame($id: ID!, $limit: Int, $nextToken: String, $available: Boolean, $publishTime: String, $filter: HighlightFilterInput) {
		getGame(id: $id) {
			id
			merlinId
			sport
			highlights(sortDirection: DESC, limit: $limit, nextToken: $nextToken, available: $available, publishTime: $publishTime, filter: $filter) {
				items {
					id
					available
					availableTime
					type
					periods {
						items {
							title
						}
					}
					publishTime
				}
				nextToken
			}
		}
	}
`;

export const getGameAirings = gql`
	query getGame($id: ID!, $limit: Int, $nextToken: String) {
		getGame(id: $id) {
			id
			merlinId
			airings(limit: $limit, nextToken: $nextToken) {
				items {
					id
					channelId
					startTime
					businessLogic
					status
					alternateIds {
						items {
							id
							alternateId
							namespace
						}
					}
					offsets {
						items {
							segment
							offset
						}
					}
					exclusionPlayIds
					editorialHighlight {
						id
						periods {
							items {
								startPosition
								endPosition
								startGameTime {
									segmentId
									segment
									position
								}
								gameEndTime {
									segmentId
									position
								}
								source {
									type
									startTime
									endTime
									channelId
								}
								title
								shortText
								description
								type
								team {
									id
								}
							}
						}
					}
					channel {
						name
						territory
						sourceAssets {
							items {
								id
								format
								url
							}
						}
					}
					drm
					sources {
						url
						drmProvider
						contentRef
						configAlias
						propositionContentId
						protection
						transport
						providerVariantId
					}
					mafStage
				}
				nextToken
			}
		}
	}
`;

export const getGameFers = gql`
	query getGameFers($id: ID!) {
		listFers(gameId: $id) {
			items {
				... on Game {
					id
					__typename
				}
				... on Fer {
					__typename
					available
					channel {
						name
						territory
						sourceAssets {
							items {
								id
								format
								url
							}
						}
					}
					channelId
					endTime
					entity
					ferId
					gameId
					startTime
				}
			}
		}
	}
`;

export const listGames = gql`
	query listGames(
		$sortDirection: SortDirection
		$limit: Int
		$startTime: String
		$endTime: String
		$nextToken: String
		$filter: ListGamesFilterInput
	) {
		listGames(sortDirection: $sortDirection, limit: $limit, startTime: $startTime, endTime: $endTime, nextToken: $nextToken, filter: $filter) {
			items {
				id
				sport
				startTime
				status
				title
				league {
					id
					name
					sport
				}
				airings {
					items {
						id
					}
				}
				excludeScheduling
			}
			nextToken
		}
	}
`;

export const getGameListItem = gql`
	query getGameListItem($id: ID!) {
		getGame(id: $id) {
			id
			airings {
				items {
					id
					channel {
						name
					}
					status
					alternateIds {
						items {
							id
							namespace
						}
					}
					drm
					highlights(sortDirection: DESC) {
						items {
							id
							type
							periods {
								items {
									id
								}
							}
						}
					}
				}
			}
		}
		listFers(gameId: $id) {
			items {
				... on Game {
					id
					__typename
				}
				... on Fer {
					__typename
					available
					channel {
						name
					}
					channelId
					endTime
					entity
					ferId
					gameId
					startTime
				}
			}
		}
	}
`;

export const getFer = gql`
	query getFer($ferId: ID!, $gameId: ID!) {
		getFer(ferId: $ferId, gameId: $gameId) {
			available
			channel {
				id
				language
				mediaLiveId
				mediaPackageId
				name
				territory
				type
			}
			channelId
			endTime
			endpoint
			entity
			ferId
			gameId
			startTime
		}
	}
`;

export const ferPresenceQuery = gql`
	query listFersForGame($gameId: ID!) {
		listFers(gameId: $gameId) {
			items {
				... on Fer {
					__typename
					ferId
				}
			}
		}
	}
`;
